import { app } from '../app';

app.factory('TokenService', TokenService);

/** @ngInject */
function TokenService() {

    return {
        setToken,
        getAccessToken,
        getRefreshToken,
        remove
    };

    function setToken(token) {
        localStorage.setItem('token', JSON.stringify(token));
    }

    function getToken() {
        const token = localStorage.getItem('token');
        return token && JSON.parse(token);
    }

    function getAccessToken() {
        const token = getToken();
        return token && token.access_token;
    }

    function getRefreshToken() {
        const token = getToken();
        return token && token.refresh_token;
    }

    function remove() {
        localStorage.removeItem('token');
    }
}



// WEBPACK FOOTER //
// ./src/portal/services/token.service.js